import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      // document.querySelector("shipcheck-cart-widget button.asc-widget-switch[aria-checked=false]").click()
      this.showDialog();
      setTimeout(function(){
        if(document.querySelector("shipcheck-cart-widget button.asc-widget-switch[aria-checked=false]")){
          document.querySelector("shipcheck-cart-widget button.asc-widget-switch[aria-checked=false]").click()
        }
      }, 100)
    }
  };

  open() {
    this.showDialog();
    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });

    setTimeout(function(){
      document.querySelector("shipcheck-cart-widget button.asc-widget-switch[aria-checked=false]").click()
    }, 100)
  }

  close() {
    this.closeDialog();
  }
  
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
